import { IconArrowsArrowLeft } from '@doltech/icons/IconArrowsArrowLeft';
import { IconArrowsArrowRight } from '@doltech/icons/IconArrowsArrowRight';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { Link } from '@doltech/ui/lib/figma/Link';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { TestTypeEnum } from '@doltech/utils/lib/constants';
import { flexGap } from '@doltech/utils/lib/css-style';
import { useTestResultStore } from '../model/test-result.hook';

export interface BottomNavigationProps extends React.HTMLAttributes<HTMLDivElement> {
  customSection?: JSX.Element;
  defaultBookCover?: any;
  sectionLeft?: JSX.Element;
}

const Main = styled.nav`
  padding: 12px 24px;

  display: grid;
  grid-template-columns: minmax(0px, 1fr) auto minmax(0px, 1fr);
  align-items: center;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  justify-self: end;

  ${flexGap(8)}
`;

const FullTestWrapper = styled.nav`
  padding: 12px 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const BottomNavigation = observer((props: BottomNavigationProps) => {
  const { children, customSection, sectionLeft, defaultBookCover, ...rest } = props;
  const store = useTestResultStore();
  const isFullTest = store.testType === TestTypeEnum.FULL_TEST;

  if (isFullTest)
    return (
      <FullTestWrapper {...rest}>
        <div className="section-left">{children}</div>
        <RightSide>
          <Link rel="noreferrer" target="_blank" href={`/${store.seoVocabUrl}`}>
            <Button.Primary>List từ vựng</Button.Primary>
          </Link>
          <Button.Secondary
            disabled={!store.canPrev}
            variant="outline"
            onClick={() => {
              if (store.preventUserAction()) return;
              store.prev();
            }}
            iconLeft={<IconArrowsArrowLeft />}
          />
          <Button.Secondary
            disabled={!store.canNext}
            variant="outline"
            onClick={() => {
              if (store.preventUserAction()) return;
              store.next();
            }}
            iconRight={<IconArrowsArrowRight />}
          />
        </RightSide>
      </FullTestWrapper>
    );

  return (
    <Main {...rest}>
      {customSection}
      <div className="section-left">{sectionLeft}</div>
      <div className="section-middle">{children}</div>
      <RightSide>
        <Link rel="noreferrer" target="_blank" href={`/${store.seoVocabUrl}`}>
          <Button.Primary>List từ vựng</Button.Primary>
        </Link>
        <Button.Secondary
          disabled={!store.canPrev}
          variant="outline"
          onClick={() => {
            if (store.preventUserAction()) return;
            store.prev();
          }}
          iconLeft={<IconArrowsArrowLeft />}
        />
        <Button.Secondary
          disabled={!store.canNext}
          variant="outline"
          onClick={() => {
            if (store.preventUserAction()) return;
            store.next();
          }}
          iconRight={<IconArrowsArrowRight />}
        />
      </RightSide>
    </Main>
  );
});
